import type { FaireProductEntity } from "../../entity_types/product";

export const p_jv32adyxhz: FaireProductEntity = {
  token: "p_jv32adyxhz",
  type: "product",
  name: "Niche Design Stackable Band Ring in 925 Sterling Silver",
  brandToken: "b_xd955m9fpf",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ed4dd3d8d6476e4d9b1f9e84abcc12581b7620f340c1de999c7b9902f63df07c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e02eca48606613537381dd29694c0480cb7ea329e2b2e10a09594170d5611181.jpeg",
    "https://cdn.faire.com/fastly/873052bfd9f33df5e7fe618ea24d83d79be7f98208ff75cbad37d6b20ac7056c.jpeg",
    "https://cdn.faire.com/fastly/a81b17bc40ed37b87d1382a270b68bbe9d037e3da33f6e5a39b71825c71a9865.jpeg",
  ],
  priceDollars: 8,
  description:
    "Description & Details\n\nThe open design makes the ring look more retro. In the coming summer, you can do your favorite manicure and wear our ring, and sit on the swing leisurely to enjoy the summer wind.\n\n * Solid 925 sterling silver \n * Hypoallergenic, gold plating \n * US size adjustable \n * All our work is custom made by hand with love ",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:56.207Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
